import React from 'react';
import classnames from 'classnames';
import ArrowRight from 'images/icons/controls/arrow-right.svg?react-svg';
import { PrimaryButton as DefaultButton } from 'scy/buttons';
import { absolute, right_sm } from 'scy/position.mod.scss';
import { tablet_hidden } from 'scy/display.mod.scss';

export default function ContinueButton({
  Button = DefaultButton,
  children,
  ...rest
}) {
  return (
    <Button {...rest}>
      {children}
      <ArrowRight className={classnames(absolute, right_sm, tablet_hidden)} />
    </Button>
  );
}
